import PageBackTitle from "../Component/PageBackTitle";
import React, { useRef, useState } from "react";
import "./UserForm.css";
import "./EquipmentForm.css";
import "./AmcSchedules.css";
import "../SafetyObservation/safetyObservation.css";
import "../SafetyMeetings/safetyMeetings.css";
import "../HsePolicies/hsePolicies.css";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import API_URL from "../../src/Config";
import HsePolicyFormFields from "../HsePolicies/HsePolicyFormFields";
import { parseApiError } from "../SafetyObservation/observationUtils";
import {
  buildHsePolicyFormData,
  INITIAL_HSE_POLICY_FORM_DATA,
} from "../HsePolicies/hsePolicyUtils";

function HsePolicyForm({ isSidebarExpanded }) {
  const navigate = useNavigate();
  const fileInputRef = useRef(null);
  const [formData, setFormData] = useState(INITIAL_HSE_POLICY_FORM_DATA);
  const [errors, setErrors] = useState({});
  const [documents, setDocuments] = useState([]);
  const [isDocumentPopupOpen, setIsDocumentPopupOpen] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const [isLoading, setIsLoading] = useState(false);

  const showSnackbar = (message, severity = "success") => {
    setSnackbarMessage(message);
    setSnackbarSeverity(severity);
    setSnackbarOpen(true);
  };

  const handleSnackbarClose = (_, reason) => {
    if (reason === "clickaway") return;
    setSnackbarOpen(false);
  };

  const validateForm = () => {
    const validationErrors = {};

    if (!formData.title.trim()) validationErrors.title = "Title is required.";

    return validationErrors;
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;

    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));

    setErrors((prevState) => ({
      ...prevState,
      [name]: "",
    }));
  };

  const handleUploadClick = () => {
    fileInputRef.current?.click();
  };

  const handleFileInputChange = (event) => {
    const selectedFiles = Array.from(event.target.files || []);
    if (selectedFiles.length === 0) return;

    setDocuments((prevState) => [...prevState, ...selectedFiles]);
    setErrors((prevState) => ({
      ...prevState,
      documents: "",
    }));
    event.target.value = "";
  };

  const handleDeleteDocument = (index) => {
    setDocuments((prevState) => prevState.filter((_, i) => i !== index));
  };

  const handleCancelClick = () => {
    navigate("/hse-policies");
  };

  const handleSaveClick = async () => {
    const validationErrors = validateForm();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    try {
      setIsLoading(true);
      const authKey = localStorage.getItem("authKey");
      const payload = buildHsePolicyFormData(formData, documents);

      const response = await axios.post(
        `${API_URL}/api/safety/hse-policies`,
        payload,
        {
          headers: {
            Authorization: authKey,
            "Content-Type": "multipart/form-data",
          },
        },
      );

      showSnackbar(response.data?.message || "HSE policy created successfully");
      window.setTimeout(() => {
        navigate("/hse-policies");
      }, 900);
    } catch (error) {
      showSnackbar(parseApiError(error, "Failed to create HSE policy"), "error");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <div
        className={`data-form-content-container page-content ${
          isSidebarExpanded ? "expanded" : "collapsed"
        }`}
      >
        <div className="data-form-content meeting-form-wrapper">
          <div className="data-form-header">
            <div className="data-form-header-content">
              <PageBackTitle className="data-form-heading-content-left-side">New HSE Policy</PageBackTitle>
            </div>
          </div>
          <div className="header-separator"></div>
          <div className="data-form-body">
            <form className="form-detail">
              <HsePolicyFormFields
                formData={formData}
                errors={errors}
                onInputChange={handleInputChange}
                fileInputRef={fileInputRef}
                documents={documents}
                isDocumentPopupOpen={isDocumentPopupOpen}
                onUploadClick={handleUploadClick}
                onFileInputChange={handleFileInputChange}
                onToggleDocumentPopup={() =>
                  setIsDocumentPopupOpen((prevState) => !prevState)
                }
                onCloseDocumentPopup={() => setIsDocumentPopupOpen(false)}
                onDeleteDocument={handleDeleteDocument}
              />
            </form>
          </div>
          <div className="footer">
            <div className="button-group">
              <button
                className="data-form-save-button"
                type="button"
                onClick={handleSaveClick}
                disabled={isLoading}
              >
                {isLoading ? "Saving..." : "Save"}
              </button>
              <button
                className="data-form-cancel-button"
                type="button"
                onClick={handleCancelClick}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>

      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        style={{ marginTop: "35px", marginLeft: "20px" }}
      >
        <MuiAlert onClose={handleSnackbarClose} severity={snackbarSeverity}>
          {snackbarMessage}
        </MuiAlert>
      </Snackbar>
    </>
  );
}

export default HsePolicyForm;
